import { axios } from "@/lib/axios";

export const getExtensionToken = (): Promise<any> => {
  return axios.post("/generateExtensionToken");
};
